'use client';

import { Suspense } from 'react';
import GroupCompany from '../components/GroupCompany';
import GroupCompanySkeleton from '../components/GroupCompanySkeleton';
import type { GroupCompanyData } from '@/types/group-company';

interface GroupCompanyClientProps {
  locale: string;
  data: GroupCompanyData | null;
}

export default function GroupCompanyClient({ locale, data }: GroupCompanyClientProps) {
  return (
    <Suspense fallback={<GroupCompanySkeleton />}>
      <GroupCompany locale={locale} data={data} />
    </Suspense>
  );
}
